import { createContext, Dispatch, SetStateAction } from 'react'

import { AmbiguousLocations } from './type'

const defaultAmbiguousLocations: AmbiguousLocations[] = []

export const AmbiguousLocationsFormContext = createContext<{
	ambiguousLocationsForm: AmbiguousLocations[]
	setAmbiguousLocationsForm: Dispatch<SetStateAction<AmbiguousLocations[]>>
	formEdited: boolean
	setFormEdited: Dispatch<SetStateAction<boolean>>
	showError: boolean
	setShowError: Dispatch<SetStateAction<boolean>>
}>({
	ambiguousLocationsForm: defaultAmbiguousLocations,
	setAmbiguousLocationsForm: () => {},
	formEdited: false,
	setFormEdited: () => {},
	showError: false,
	setShowError: () => {},
})
